import src from "IMAGE";
export default { src, width: 221, height: 61, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADRxtF0XXKdnFlypZhVcqFwWXahUFVyoTBVcqVAsbLJkAJCivCM6S2Y/MEhlRi5HZD4vSmM9L0ZiOjRObDiKo78iCOoW7RQ0cX4AAAAASUVORK5CYII="};
